import { CalendarDays, ChevronDown } from 'lucide-react';
import styles from './YearSelector.module.css';

const YearSelector = ({
  years = [],
  value,
  onChange,
  label = 'Anno dati',
  tone = 'light',
  compact = false,
  className = '',
}) => (
  <label
    className={[
      styles.field,
      styles[tone],
      compact ? styles.compact : '',
      className,
    ].filter(Boolean).join(' ')}
  >
    {!compact && <span className={styles.label}>{label}</span>}
    <span className={styles.control}>
      <CalendarDays className={styles.icon} size={compact ? 14 : 17} aria-hidden="true" />
      <select
        aria-label={label}
        value={value ?? ''}
        onChange={(event) => onChange(Number(event.target.value))}
        disabled={!years.length}
      >
        {!years.length && <option value="">Nessun anno</option>}
        {years.map((year) => (
          <option key={year} value={year}>Anno {year}</option>
        ))}
      </select>
      <ChevronDown className={styles.chevron} size={compact ? 13 : 16} aria-hidden="true" />
    </span>
  </label>
);

export default YearSelector;
